import { commonFilter } from './filter';

export default function (path: string) {
  return {
    pageName: 'newsletter',
    pageId: '20111',
    pagePath: path,
    common: {
      source: 2,
      typeId: 'opinion_pc_v2',
    },
    button: {
      ...commonFilter,
    },
  };
}
